/* Keep the visible product, cart variant and URL in sync. */
(function () {
  function init(section) {
    if (section.dataset.variantInitialized === 'true') return;
    section.dataset.variantInitialized = 'true';
    var select = section.querySelector('[data-variant-select]');
    if (!select) return;
    var form = select.closest('form');
    var price = section.querySelector('[data-variant-price]');
    var stock = section.querySelector('[data-variant-stock]');
    var sku = section.querySelector('[data-variant-sku-label]');
    var button = form.querySelector('[data-variant-add]');
    var bar = document.querySelector('[data-buybar]');
    var stickyPrice = document.querySelector('[data-variant-sticky-price]');
    var stickyButton = document.querySelector('[data-sticky-add]');

    function update(changeUrl) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var validPrice = option.dataset.priceOk === 'true';
      var available = option.dataset.available === 'true';
      var canBuy = validPrice && available;
      var submitting = form.getAttribute('data-submitting') === 'true';
      if (price) {
        price.textContent = '';
        if (validPrice && option.dataset.compare) {
          var was = document.createElement('span');
          was.className = 'pcard__was';
          was.textContent = option.dataset.compare;
          price.appendChild(was);
          price.appendChild(document.createTextNode(' '));
        }
        price.appendChild(document.createTextNode(validPrice ? option.dataset.price : 'Price unavailable'));
      }
      if (stock) {
        stock.textContent = canBuy ? 'In stock' : (validPrice ? 'Currently sold out' : 'Price unavailable');
        stock.classList.toggle('stock--ok', canBuy);
        stock.classList.toggle('stock--out', !canBuy);
      }
      if (sku) sku.textContent = option.dataset.sku ? 'SKU: ' + option.dataset.sku : '';
      if (button) {
        button.disabled = !canBuy || submitting;
        button.textContent = canBuy ? 'Add to cart' : (validPrice ? 'Sold out' : 'Unavailable');
      }
      if (bar) bar.hidden = !canBuy;
      if (stickyButton) stickyButton.disabled = !canBuy || submitting;
      if (stickyPrice) stickyPrice.textContent = validPrice ? option.dataset.price : 'Price unavailable';
      var imageIndex = option.dataset.imageIndex;
      var thumb = section.querySelector('[data-thumb][data-index="' + imageIndex + '"]');
      if (thumb) {
        thumb.click();
        var strip = thumb.closest(".product__thumbs");
        if (strip) {
          var itemBounds = thumb.getBoundingClientRect();
          var stripBounds = strip.getBoundingClientRect();
          if (itemBounds.left < stripBounds.left || itemBounds.right > stripBounds.right) {
            strip.scrollLeft += itemBounds.left - stripBounds.left - (strip.clientWidth - itemBounds.width) / 2;
          }
        }
      }
      else {
        var image = section.querySelector('[data-main-img]');
        if (image && option.dataset.image) image.src = option.dataset.image;
      }
      section.querySelectorAll('.product__desc [data-variant-sku]').forEach(function (description) {
        description.hidden = description.getAttribute('data-variant-sku') !== option.dataset.sku;
      });
      if (changeUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', function () { update(true); });
    form.addEventListener('mha:cart-settled', function () { update(false); });
    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      if (id && Array.prototype.some.call(select.options, function (option) { return option.value === id; })) {
        select.value = id;
        update(false);
      }
    });
    update(false);
  }
  document.querySelectorAll('[data-product-section]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-section]').forEach(init);
  });
})();
